/* ============================================================
   BB Collection Cards — Quick-add AJAX handler
   ============================================================ */
(function () {
  'use strict';

  function context() {
    var p = location.pathname;
    if (/\/search\b/.test(p)) return 'search';
    if (/\/collections\//.test(p)) return 'collection';
    if (/\/products\//.test(p)) return 'pdp';
    return 'other';
  }
  function collectionHandle() {
    var m = location.pathname.match(/\/collections\/([^\/?#]+)/);
    return m ? m[1] : null;
  }
  function productHandle(data) {
    if (data && data.handle) return data.handle;
    if (data && data.url) {
      var m = String(data.url).match(/\/products\/([^\/?#]+)/);
      if (m) return m[1];
    }
    return null;
  }

  // ---- Optimistic line support ------------------------------------------
  // The collection grid is rendered client-side by bb-collection-filter.js from
  // the #bb-cf-data island (a { count, page, pages, products } object). Each
  // product carries display data we can hand the cart drawer so it renders the
  // tapped product INSTANTLY, before /cart/add resolves — no extra request.
  // Fields used: p.t title, p.v vendor, p.u url, p.img image,
  //              p.p price (cents), p.cap compare-at (cents).
  var _idx = null;
  function islandIndex() {
    if (_idx) return _idx;
    _idx = {};
    var el = document.getElementById('bb-cf-data');
    if (!el) return _idx;
    var data;
    try { data = JSON.parse(el.textContent); } catch (e) { return _idx; }
    var list = Array.isArray(data) ? data : (data && data.products) || [];
    for (var i = 0; i < list.length; i++) {
      var p = list[i];
      if (p && p.id != null) _idx[String(p.id)] = p;
    }
    return _idx;
  }

  function buildOptimistic(btn, variantId, size) {
    var card = btn.closest('.bb-cf-card');
    var pid = card && card.getAttribute('data-product-id');
    if (!pid) return null;
    var p = islandIndex()[String(pid)];
    if (!p) return null;
    var priceCents   = (typeof p.p === 'number') ? p.p : 0;
    var compareCents = (typeof p.cap === 'number') ? p.cap : 0;
    // Prefer an image the browser has ALREADY decoded on the card so the drawer
    // paints from cache instantly (no different-size re-download / blank frame).
    // Handles both markups: the server twin's single .bb-cf-media__main and the
    // client engine's .bb-cf-media--rail of .bb-rail__img. Grab the first loaded
    // image in the media area; fall back to the first image, then the island url.
    var media = card.querySelector('.bb-cf-media') || card;
    var cands = media.querySelectorAll('img');
    var img = '';
    for (var ci = 0; ci < cands.length; ci++) {
      var im = cands[ci];
      var src = im.currentSrc || im.src;
      if (src && im.complete && im.naturalWidth > 0) { img = src; break; }
    }
    if (!img && cands[0]) img = cands[0].currentSrc || cands[0].src || '';
    if (!img) img = p.img || '';
    return {
      variantId: variantId,
      size: size,
      title: p.t || '',
      vendor: p.v || '',
      image: img,
      url: p.u || '',
      priceCents: priceCents,
      compareCents: compareCents,
      stock: null // inventory isn't in the island; drawer omits the low-stock cue
    };
  }

  function bbToast(message) {
    var t = document.getElementById('bb-cg-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'bb-cg-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      t.style.cssText = [
        'position:fixed',
        'left:50%',
        'bottom:24px',
        'transform:translateX(-50%) translateY(8px)',
        'z-index:10001',
        'max-width:calc(100vw - 32px)',
        'padding:12px 18px',
        'background:#ffffff',
        'color:#1a1a1a',
        'border-left:3px solid #b84e2d',
        'box-shadow:0 6px 28px rgba(0,0,0,.14)',
        'border-radius:4px',
        'font-family:Montserrat, sans-serif',
        'font-size:11px',
        'font-weight:500',
        'letter-spacing:.03em',
        'line-height:1.4',
        'text-align:center',
        'opacity:0',
        'pointer-events:none',
        'transition:opacity .22s ease, transform .22s ease'
      ].join(';');
      document.body.appendChild(t);
    }
    t.textContent = message;
    void t.offsetWidth;
    t.style.opacity = '1';
    t.style.transform = 'translateX(-50%) translateY(0)';
    clearTimeout(t._hideTimer);
    t._hideTimer = setTimeout(function () {
      t.style.opacity = '0';
      t.style.transform = 'translateX(-50%) translateY(8px)';
    }, 2800);
  }

  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest('[data-bb-cg-trigger]');
      if (!btn || btn.dataset.bbCgLoading || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.dataset.variantId;
      const size = btn.dataset.size;
      if (!variantId) return;
      btn.dataset.bbCgLoading = '1';
      btn.classList.add('bb-cg-loading');

      // Open the cart WITH an optimistic line so the product renders instantly,
      // before the network request completes.
      var optimistic = buildOptimistic(btn, variantId, size);
      document.dispatchEvent(new CustomEvent('cart:adding', {
        bubbles: true,
        detail: optimistic ? { optimistic: optimistic } : {}
      }));

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1
        }),
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (b) { throw new Error(b.description || 'HTTP ' + r.status); });
          return r.json();
        })
        .then(function (data) {
          delete btn.dataset.bbCgLoading;
          btn.classList.remove('bb-cg-loading');
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          if (typeof window.bbTrack === 'function') {
            var ch = collectionHandle();
            var params = {
              variant_id: variantId,
              size: size,
              product_id: data.product_id,
              product_handle: productHandle(data),
              designer: data.vendor,
              price: (typeof data.price === 'number') ? data.price / 100 : undefined,
              context: context()
            };
            if (ch) params.collection_handle = ch;
            window.bbTrack('bb_quick_add', params);
          }
        })
        .catch(function (err) {
          console.error('[BB CollectionCards]', err);
          delete btn.dataset.bbCgLoading;
          btn.classList.remove('bb-cg-loading');
          document.dispatchEvent(new CustomEvent('cart:add-failed', { bubbles: true }));
          var msg = (err && err.message && err.message.indexOf('HTTP') !== 0)
            ? err.message
            : 'Sorry, we couldn’t add that to your bag.';
          bbToast(msg);
        });
    },
    true
  );
})();
